import React from 'react'
import { Text, csx } from '@vtex/admin-ui'
import { FormattedNumber } from 'react-intl'

type AssemblyItemsFormattedPriceProps = {
  value: number | null | undefined
  currencyCode: string
  isDisabled: boolean
}

export const AssemblyItemsFormattedPrice = ({
  value,
  currencyCode,
  isDisabled,
}: AssemblyItemsFormattedPriceProps) => (
  <Text
    className={csx({
      color: isDisabled ? '#747474 !important' : '',
    })}
  >
    <FormattedNumber
      style="currency"
      currency={currencyCode}
      value={value != null ? value / 100 : 0}
    />
  </Text>
)
